<template>
<div>
<v-card
    class="mx-auto"
    outlined
    color="#006699"
    style="color:white"
  >
 <!-- ===================================== DIALOGO DE SELEÇÃO DO PRODUTO INICIAL================================= -->
                   <template>
               <v-row justify="center">
                <v-dialog v-model="dialog"  max-width="850px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Selecione o intervalo de Filtragem</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                            <v-col md="12">
                               <v-data-table :headers="headersTabela" :items="clientes">
                                  <template v-slot:item.selecione="{ item }">
                                     <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn color="#006699" style="color:white;" @click="SelecionaProduto(item)" v-on="on" v-bind="attrs" fab small><v-icon>done</v-icon></v-btn>
                                        </template>
                                        <span>Clique neste botão para selecionar este Produto.</span>
                                    </v-tooltip>
                                  </template>
                               </v-data-table>
                            </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-row>
            </template>

        <!-- ====================================== Fim do DIALOGO =============================================== -->
        <!-- ===================================== DIALOGO DE SELEÇÃO DO PRODUTO INICIAL================================= -->
                   <template>
               <v-row justify="center">
                <v-dialog v-model="dialogFinal"  max-width="850px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Selecione o intervalo de Filtragem</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                            <v-col md="12">
                               <v-data-table :headers="headersTabela" :items="clientes">
                                  <template v-slot:item.selecione="{ item }">
                                     <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn color="#006699" style="color:white;" @click="SelecionaProdutoFinal(item)" v-on="on" v-bind="attrs" fab small><v-icon>done</v-icon></v-btn>
                                        </template>
                                        <span>Clique neste botão para selecionar este Produto.</span>
                                    </v-tooltip>
                                  </template>
                               </v-data-table>
                            </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-row>
            </template>

        <!-- ====================================== Fim do DIALOGO =============================================== -->

  <v-card-title>Relatório de Stocks</v-card-title>
    <v-card-text>
      <v-expansion-panels focusable>
    <v-expansion-panel
    >
      <v-expansion-panel-header style="font-size:16px;font-weight:bold;color:#006699">Listagem dos Produtos</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row>
       <table style="width:100%;">
                        <tr>
                          <td  style="width:80%;">
                              <p style="margin-left:-10px;font-weight:bold;">Critérios de Filtragem e Ordenação</p>
                              <v-row style="border:1px solid #ccc;width:700px;margin-top:-15px;">
                                <v-col md="6"><span>Filtragem por:</span>
                                  <v-select
                                        v-model="filtragemSelecionada"
                                        :items="campos"
                                        item-text="descricao"
                                        item-value="descricao"
                                        label="Selecione o campo"
                                        color="white;"
                                        @change="SelecionaFiltragem()"
                                      ></v-select>
                                </v-col>
                                <v-col md="6"><span>E ordenada por:</span>
                                  <v-select
                                        v-model="ordenacaoSelecionada"
                                        :items="campos"
                                        item-text="descricao"
                                        item-value="descricao"
                                        label="Selecione o campo"
                                        color="white;"
                                      ></v-select>
                                </v-col>
                              <v-col md="5">
                                <span>{{filtragemInicial}}</span>
                                <v-text-field  label="Inicio" :disabled="true" v-model="txtInicial" ></v-text-field>
                                </v-col>
                                <v-col md="1">
                                  <v-btn fab small @click="PesquisarCliente('inicio1')" style="margin-top:33px;margin-left:-10px;"><v-icon>search</v-icon></v-btn>
                                </v-col>
                                <v-col md="5"><span>{{filtragemFinal}}</span>
                                  <v-text-field  v-model="txtFinal" :disabled="true" label="Fim" ></v-text-field>
                                </v-col>
                                <v-col md="1">
                                    <v-btn fab small @click="PesquisarProdutoFinal('fim1')"  style="margin-top:33px;margin-left:-10px;"><v-icon>search</v-icon></v-btn>
                                </v-col>
                              </v-row>
                          </td>
                           <td>
                             <span style="font-size:16px;font-weight:bold;">Descrição:</span><span>Listagem de Produtos</span>
                             <div style="border:1px solid #cccccc;">
                               <p style="padding:10px;">Lista todos os Produtos existentes em Stock.</p>
                             </div>
                               <p style="margin-left:-10px;font-weight:bold;">Botões de Ação/Exportação</p>
                              <v-row style="border:1px solid #ccc;width:420px;margin-top:-15px;background-color:#006699;">
                                <v-col md="4">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn color="green"
                                            fab
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="CarregarTabela()"
                                            style="color:white;">
                                            <v-icon>restore</v-icon>
                                          </v-btn>
                                        </template>
                                        <span>Clique neste botão para visualizar os dados, que serão apresentados segundo os critérios de filtragem e ordenação.</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col md="4">
                                  <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn fab
                                          v-bind="attrs"
                                            v-on="on"
                                           color="white" >
                                            <img width="30px" src="../../assets/pdf_exibir.png">
                                          </v-btn>
                                        </template>
                                        <span>Clique aqui para exportar os dados em PDF.</span>
                                   </v-tooltip>
                                </v-col>
                                <v-col md="4">
                                  <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                          fab
                                           v-bind="attrs"
                                            v-on="on"
                                          color="white"
                                          >
                                            <img width="30px" src="../../assets/download.png">
                                          </v-btn>
                                        </template>
                                        <span>Clique aqui para exportar os dados em Excel.</span>
                                   </v-tooltip>
                                </v-col>
                              </v-row>
                            </td>
                        </tr>
                      </table>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel
    >
      <v-expansion-panel-header style="font-size:16px;font-weight:bold;color:#006699">Valorização de Stocks</v-expansion-panel-header>
      <v-expansion-panel-content>
       <v-row>
       <table style="width:100%;">
                        <tr>
                          <td  style="width:80%;">
                              <p style="margin-left:-10px;font-weight:bold;">Critérios de Filtragem e Ordenação</p>
                              <v-row style="border:1px solid #ccc;width:700px;margin-top:-15px;">
                                <v-col md="6"><span>Filtragem por:</span>
                                  <v-select
                                        v-model="filtragemSelecionada"
                                        :items="campos"
                                        item-text="descricao"
                                        item-value="descricao"
                                        label="Selecione o campo"
                                        color="white;"
                                        @change="SelecionaFiltragem()"
                                      ></v-select>
                                </v-col>
                                <v-col md="6"><span>E ordenada por:</span>
                                  <v-select
                                        v-model="ordenacaoSelecionada"
                                        :items="campos"
                                        item-text="descricao"
                                        item-value="descricao"
                                        label="Selecione o campo"
                                        color="white;"
                                      ></v-select>
                                </v-col>
                              <v-col md="5">
                                <span>{{filtragemInicial}}</span>
                                <v-text-field :disabled="true"   label="Inicio" v-model="txtValorizacaoInicial" ></v-text-field>
                                </v-col>
                                <v-col md="1">
                                  <v-btn fab small @click="PesquisarCliente('inicio2')" style="margin-top:33px;margin-left:-10px;"><v-icon>search</v-icon></v-btn>
                                </v-col>
                                <v-col md="5"><span>{{filtragemFinal}}</span>
                                  <v-text-field :disabled="true"  v-model="txtValorizacaoFinal" label="Fim" ></v-text-field>
                                </v-col>
                                <v-col md="1">
                                    <v-btn fab small @click="PesquisarProdutoFinal('fim2')"  style="margin-top:33px;margin-left:-10px;"><v-icon>search</v-icon></v-btn>
                                </v-col>
                                <v-col md="6">
                                   <span>Da data:</span>
                                   <template>
                                    <v-menu
                                      ref="menuDataInicio"
                                      v-model="menuDataInicio"
                                      :close-on-content-click="false"
                                      transition="scale-transition"
                                      offset-y
                                      full-width
                                      min-width="290px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          v-model="TxtdataInicio"
                                          :rules="[v => !!v || 'Campo obrigatorio!']"
                                          label="Data inicio"
                                          prepend-icon="event"
                                          readonly
                                          v-on="on"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker
                                        ref="picker"
                                        max="2025-12-31"
                                        min="2000-01-01"
                                        v-model="dataInicio"
                                        @change="saveDataInicio"
                                      ></v-date-picker>
                                    </v-menu>
                                    </template>
                                </v-col>
                                 <v-col md="6">
                                   <span>A data:</span>
                                   <template>
                                    <v-menu
                                      ref="menuDataFinal"
                                      v-model="menuDataFinal"
                                      :close-on-content-click="false"
                                      transition="scale-transition"
                                      offset-y
                                      full-width
                                      min-width="290px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          v-model="TxtdataFinal"
                                          :rules="[v => !!v || 'Campo obrigatorio!']"
                                          label="Data Final"
                                          prepend-icon="event"
                                          readonly
                                          v-on="on"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker
                                        ref="picker"
                                        max="2025-12-31"
                                        min="2000-01-01"
                                        v-model="dataFinal"
                                        @change="saveDataFinal"
                                      ></v-date-picker>
                                    </v-menu>
                                    </template>
                                </v-col>
                              </v-row>
                          </td>
                           <td>
                             <span style="font-size:16px;font-weight:bold;">Descrição:</span><span>Valorização de Stocks</span>
                             <div style="border:1px solid #cccccc;">
                               <p style="padding:10px;">Indica o valor das Existências a Preço Médio de Custo(ou a Preço de Custo ).</p>
                             </div>
                               <p style="margin-left:-10px;font-weight:bold;">Botões de Ação/Exportação</p>
                              <v-row style="border:1px solid #ccc;width:420px;margin-top:-15px;background-color:#006699;">
                                <v-col md="4">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn color="green"
                                            fab
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="CarregarTabelaStock()"
                                            style="color:white;">
                                            <v-icon>restore</v-icon>
                                          </v-btn>
                                        </template>
                                        <span>Clique neste botão para visualizar os dados, que serão apresentados segundo os critérios de filtragem e ordenação.</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col md="4">
                                  <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn fab
                                          v-bind="attrs"
                                            v-on="on"
                                           color="white" >
                                            <img width="30px" src="../../assets/pdf_exibir.png">
                                          </v-btn>
                                        </template>
                                        <span>Clique aqui para exportar os dados em PDF.</span>
                                   </v-tooltip>
                                </v-col>
                                <v-col md="4">
                                  <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                          fab
                                           v-bind="attrs"
                                            v-on="on"
                                          color="white"
                                          >
                                            <img width="30px" src="../../assets/download.png">
                                          </v-btn>
                                        </template>
                                        <span>Clique aqui para exportar os dados em Excel.</span>
                                   </v-tooltip>
                                </v-col>
                              </v-row>
                            </td>
                        </tr>
                      </table>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel
    >
      <v-expansion-panel-header style="font-size:16px;font-weight:bold;color:#006699">Clientes por Produto</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row>
       <table style="width:100%;">
                        <tr>
                          <td  style="width:80%;">
                              <p style="margin-left:-10px;font-weight:bold;">Critérios de Filtragem e Ordenação</p>
                              <v-row style="border:1px solid #ccc;width:700px;margin-top:-15px;">
                                <v-col md="6"><span>Filtragem por:</span>
                                  <v-select
                                        v-model="filtragemSelecionada"
                                        :items="campos"
                                        item-text="descricao"
                                        item-value="descricao"
                                        label="Selecione o campo"
                                        color="white;"
                                        @change="SelecionaFiltragem()"
                                      ></v-select>
                                </v-col>
                                <v-col md="6"><span>E ordenada por:</span>
                                  <v-select
                                        v-model="ordenacaoSelecionada"
                                        :items="campos"
                                        item-text="descricao"
                                        item-value="descricao"
                                        label="Selecione o campo"
                                        color="white;"
                                      ></v-select>
                                </v-col>
                              <v-col md="5">
                                <span>{{filtragemInicial}}</span>
                                <v-text-field  label="Inicio" v-model="txtInicial" ></v-text-field>
                                </v-col>
                                <v-col md="1">
                                  <v-btn fab small @click="PesquisarCliente()" style="margin-top:33px;margin-left:-10px;"><v-icon>search</v-icon></v-btn>
                                </v-col>
                                <v-col md="5"><span>{{filtragemFinal}}</span>
                                  <v-text-field  v-model="txtFinal" label="Fim" ></v-text-field>
                                </v-col>
                                <v-col md="1">
                                    <v-btn fab small @click="PesquisarClienteFinal()"  style="margin-top:33px;margin-left:-10px;"><v-icon>search</v-icon></v-btn>
                                </v-col>
                              </v-row>
                          </td>
                           <td>
                             <span style="font-size:16px;font-weight:bold;">Descrição:</span><span> Clientes por Produto</span>
                             <div style="border:1px solid #cccccc;">
                               <p style="padding:10px;">Mostra quais os Clientes que movimentaram os diversos produtos e em qual documento.</p>
                             </div>
                               <p style="margin-left:-10px;font-weight:bold;">Botões de Ação/Exportação</p>
                              <v-row style="border:1px solid #ccc;width:420px;margin-top:-15px;background-color:#006699;">
                                <v-col md="4">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn color="green"
                                            fab
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="CarregarTabela()"
                                            style="color:white;">
                                            <v-icon>restore</v-icon>
                                          </v-btn>
                                        </template>
                                        <span>Clique neste botão para visualizar os dados, que serão apresentados segundo os critérios de filtragem e ordenação.</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col md="4">
                                  <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn fab
                                          v-bind="attrs"
                                            v-on="on"
                                           color="white" >
                                            <img width="30px" src="../../assets/pdf_exibir.png">
                                          </v-btn>
                                        </template>
                                        <span>Clique aqui para exportar os dados em PDF.</span>
                                   </v-tooltip>
                                </v-col>
                                <v-col md="4">
                                  <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                          fab
                                           v-bind="attrs"
                                            v-on="on"
                                          color="white"
                                          >
                                            <img width="30px" src="../../assets/download.png">
                                          </v-btn>
                                        </template>
                                        <span>Clique aqui para exportar os dados em Excel.</span>
                                   </v-tooltip>
                                </v-col>
                              </v-row>
                            </td>
                        </tr>
                      </table>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel
    >
      <v-expansion-panel-header style="font-size:16px;font-weight:bold;color:#006699">Existências em Armazém</v-expansion-panel-header>
      <v-expansion-panel-content>
         <v-row>
       <table style="width:100%;">
                        <tr>
                          <td  style="width:80%;">
                              <p style="margin-left:-10px;font-weight:bold;">Critérios de Filtragem e Ordenação</p>
                              <v-row style="border:1px solid #ccc;width:700px;margin-top:-15px;">
                                <v-col md="6"><span>Filtragem por:</span>
                                  <v-select
                                        v-model="filtragemSelecionada"
                                        :items="campos"
                                        item-text="descricao"
                                        item-value="descricao"
                                        label="Selecione o campo"
                                        color="white;"
                                        @change="SelecionaFiltragem()"
                                      ></v-select>
                                </v-col>
                                <v-col md="6"><span>E ordenada por:</span>
                                  <v-select
                                        v-model="ordenacaoSelecionada"
                                        :items="campos"
                                        item-text="descricao"
                                        item-value="descricao"
                                        label="Selecione o campo"
                                        color="white;"
                                      ></v-select>
                                </v-col>
                              <v-col md="5">
                                <span>{{filtragemInicial}}</span>
                                <v-text-field :disabled="true" label="Inicio" v-model="txtArmazemInicial" ></v-text-field>
                                </v-col>
                                <v-col md="1">
                                  <v-btn fab small @click="PesquisarCliente('inicio4')" style="margin-top:33px;margin-left:-10px;"><v-icon>search</v-icon></v-btn>
                                </v-col>
                                <v-col md="5"><span>{{filtragemFinal}}</span>
                                  <v-text-field :disabled="true" v-model="txtArmazemFinal" label="Fim" ></v-text-field>
                                </v-col>
                                <v-col md="1">
                                    <v-btn fab small @click="PesquisarProdutoFinal('fim4')"  style="margin-top:33px;margin-left:-10px;"><v-icon>search</v-icon></v-btn>
                                </v-col>
                              </v-row>
                          </td>
                           <td>
                             <span style="font-size:16px;font-weight:bold;">Descrição:</span><span>Existências em Armazém</span>
                             <div style="border:1px solid #cccccc;">
                               <p style="padding:10px;">Mostra existências em um ou vários armazens.</p>
                             </div>
                               <p style="margin-left:-10px;font-weight:bold;">Botões de Ação/Exportação</p>
                              <v-row style="border:1px solid #ccc;width:420px;margin-top:-15px;background-color:#006699;">
                                <v-col md="4">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn color="green"
                                            fab
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="CarregarTabelaArmazem()"
                                            style="color:white;">
                                            <v-icon>restore</v-icon>
                                          </v-btn>
                                        </template>
                                        <span>Clique neste botão para visualizar os dados, que serão apresentados segundo os critérios de filtragem e ordenação.</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col md="4">
                                  <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn fab
                                          v-bind="attrs"
                                            v-on="on"
                                           color="white" >
                                            <img width="30px" src="../../assets/pdf_exibir.png">
                                          </v-btn>
                                        </template>
                                        <span>Clique aqui para exportar os dados em PDF.</span>
                                   </v-tooltip>
                                </v-col>
                                <v-col md="4">
                                  <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                          fab
                                           v-bind="attrs"
                                            v-on="on"
                                          color="white"
                                          >
                                            <img width="30px" src="../../assets/download.png">
                                          </v-btn>
                                        </template>
                                        <span>Clique aqui para exportar os dados em Excel.</span>
                                   </v-tooltip>
                                </v-col>
                              </v-row>
                            </td>
                        </tr>
                      </table>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
    </v-card-text>

    <v-card-actions>
       <span style="color:white;font-size:13px;">*Nota: Relatórios contendo os resumos dos dados armazenados.</span>
    </v-card-actions>
  </v-card>
</div>
</template>
<script>
import axios from '../../plugins/axios'
export default {
  data: () => ({
    campos: [
      { descricao: 'Código do Produto' },
      { descricao: 'Descrição do Produto' }
    ],
    isLoading_: false,
    search: '',
    menuFab: null,
    menuExp: null,
    produtosDesconto: [],
    filtragemSelecionada: null,
    ordenacaoSelecionada: null,
    clientes: [],
    opcaodescontoglobal: null,
    opcaoSelecionada: null,
    descontoFlag: false,
    flagDescontoGlobal: false,
    dataFinal: null,
    dataInicio: null,
    menuDataInicio: null,
    menuDataFinal: null,
    TxtdataFinal: '//',
    TxtdataInicio: '//',
    dataExpiracao: '',
    dialogFinal: false,
    dataFabrico: '',
    eventoOrigemInicial: null,
    eventoOrigemFinal: null,
    txtInicial: null,
    txtArmazemInicial: null,
    txtArmazemFinal: null,
    txtFinal: null,
    txtValorizacaoInicial: null,
    txtValorizacaoFinal: null,
    produtoSelecionado: null,
    valid: true,
    overlay: false,
    produtos: [],
    alert: false,
    filtragemInicial: 'Código inicial',
    filtragemFinal: 'Código final',
    iconAlert: '',
    alertType: '',
    campo: 'codigo',
    campoOrdenacao: '',
    colorAlert: '',
    dialog: false,
    headersTabela: [
      {
        text: 'Código',
        align: 'start',
        sortable: false,
        value: 'pkProduto'
      },
      { text: 'descrição', value: 'produto' },
      { text: 'Armazem', value: 'armazem' },
      { text: 'Stock existente', value: 'entrada_stk' },
      { text: 'Preço de venda', value: 'precoComIva' },
      { text: 'Selecione aqui', value: 'selecione' }
    ]
  }),
  watch: {
    menuDataInicio (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menuDataFinal (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },
  created () {
    this.filtragemSelecionada = this.campos[0]
    this.ordenacaoSelecionada = this.campos[0]
    this.produtosFindall()
  },
  methods: {
    async produtosFindall () {
      try {
        //   let  payload =""
        this.overlay = true
        this.clientes = await axios
          .get('/produtosFindallAsc')
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    SelecionaFiltragem () {
      if (this.filtragemSelecionada === 'Código do Produto') { this.filtragemInicial = 'Código inicial'; this.filtragemFinal = 'Código final'; this.campo = 'codigo' };
      if (this.filtragemSelecionada === 'Descrição do Produto') { this.filtragemInicial = 'Descrição inicial'; this.filtragemFinal = 'Descrição final'; this.campo = 'nome' };
    },
    SelecionaProduto (item) {
      if (this.eventoOrigemInicial === 'inicio1') {
        if (this.campo === 'codigo') { this.txtInicial = item.pkProduto }
        if (this.campo === 'nome') { this.txtInicial = item.produto }
      } else if (this.eventoOrigemInicial === 'inicio2') {
        if (this.campo === 'codigo') { this.txtValorizacaoInicial = item.pkProduto }
        if (this.campo === 'nome') { this.txtValorizacaoInicial = item.produto }
      } else if (this.eventoOrigemInicial === 'inicio4') {
        if (this.campo === 'codigo') { this.txtArmazemInicial = item.pkProduto }
        if (this.campo === 'nome') { this.txtArmazemInicial = item.produto }
      }
      this.dialog = false
    },
    SelecionaProdutoFinal (item) {
      if (this.eventoOrigemFinal === 'fim1') {
        if (this.campo === 'codigo') { this.txtFinal = item.pkProduto }
        if (this.campo === 'nome') { this.txtFinal = item.produto }
      } else if (this.eventoOrigemFinal === 'fim2') {
        if (this.campo === 'codigo') { this.txtValorizacaoFinal = item.pkProduto }
        if (this.campo === 'nome') { this.txtValorizacaoFinal = item.produto }
      } else if (this.eventoOrigemFinal === 'fim4') {
        if (this.campo === 'codigo') { this.txtArmazemFinal = item.pkProduto }
        if (this.campo === 'nome') { this.txtArmazemFinal = item.produto }
      }
      this.dialogFinal = false
    },
    PesquisarCliente (origemEvento) {
      this.dialog = true
      this.eventoOrigemInicial = origemEvento
    },
    PesquisarProdutoFinal (origemEvento) {
      this.dialogFinal = true
      this.eventoOrigemFinal = origemEvento
    },
    CarregarTabela () {
      let params = { filtragem: this.campo, inicial: this.txtInicial, final: this.txtFinal }
      this.$store.state.camposListagemProduto = params
      this.$router.push('listagem-produtos')
    },
    CarregarTabelaStock () {
      let params = { filtragem: this.campo, inicial: this.txtValorizacaoInicial, final: this.txtValorizacaoFinal, dataInicio: this.TxtdataInicio, dataFim: this.TxtdataFinal }
      this.$store.state.camposListagemProduto = params
      this.$router.push('valorizacao-stock')
    },
    CarregarTabelaArmazem () {
      let params = { filtragem: this.campo, inicial: this.txtArmazemInicial, final: this.txtArmazemFinal, dataInicio: this.TxtdataInicio, dataFim: this.TxtdataFinal }
      this.$store.state.camposListagemProduto = params
      this.$router.push('existenciaArmazem')
    },
    saveDataInicio (data) {
      this.$refs.menuDataInicio.save(data)
      this.TxtdataInicio = data
    },
    saveDataFinal (data) {
      this.$refs.menuDataFinal.save(data)
      this.TxtdataFinal = data
    }
  }
}
</script>
